import styled from 'styled-components'
import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

import SimpleLink from '../../../components/display/SimpleLink'

export const Title = styled.h2`
  ${typeStyle('-ds-font-title-2-regular')}
  margin: 0;
  color: ${({ theme }) => theme['-ds-core-300'].value};
`

export const EscapeLink = styled(SimpleLink)`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }

  color: ${({ theme }) => theme['-ds-neutral-600'].value};
`

export const Item = styled.li`
  ${typeStyle('-ds-font-lead-sm-light')}
  padding: 0;

  line-height: 2;
`

export const List = styled.ul<{ columns?: number }>`
  margin: 20px 0;
  padding: 0;
  list-style: none;

  ${media.md`
    columns: ${({ columns = 3 }: { columns?: number }) => columns};
    max-width: 1000px;
  `}
`

export const Outer = styled.div`
  padding: 16px;

  ${media.md`
    padding: 60px;
  `}
`
